/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import ApiCredentialModel from 'cio/models/api-credential';
import ApiCredentialsService from 'cio/services/api-credentials';

interface CredentialsDropdownArgs {
  prompt?: string;
  autoLoadCredentials?: boolean;
  isDisabled?: boolean;
  selectedCredential?: ApiCredentialModel;
  onSelect: (credential: ApiCredentialModel) => unknown;
}

export default class CredentialsDropdown extends Component<CredentialsDropdownArgs> {
  @service apiCredentials!: ApiCredentialsService;

  get autoLoadCredentials(): boolean {
    return this.args.autoLoadCredentials ?? true;
  }

  get prompt() {
    return this.args.prompt ?? 'Select credentials…';
  }

  @action
  loadCredentials() {
    if (this.autoLoadCredentials) {
      this.apiCredentials.loadCurrentEnvironmentCredentials.perform();
    }
  }

  @action
  didSelectCredential(credential: ApiCredentialModel) {
    this.args.onSelect(credential);
  }
}
